const toolbarElement = document.getElementById("shopify-section-toolbar");
const countdownHeaderElement = document.getElementById("countdownHeader");
const siteHeaderElement = document.getElementById("SiteHeader");

function initHeight() {
  const toolbarHeight = toolbarElement
    ? toolbarElement.getBoundingClientRect().height.toFixed(1) + "px"
    : "0px";

  const countdownHeaderHeight = countdownHeaderElement
    ? countdownHeaderElement.getBoundingClientRect().height.toFixed(1) + "px"
    : "0px";

  const headerHeight = siteHeaderElement
    ? siteHeaderElement.getBoundingClientRect().height.toFixed(1) + "px"
    : "0px";

  document.documentElement.style.setProperty('--headerHeight', headerHeight);
  document.documentElement.style.setProperty('--toolbarHeight', toolbarHeight);
  document.documentElement.style.setProperty('--countdownHeaderHeight', countdownHeaderHeight);
}

initHeight();

let resizeTimer = null;
window.addEventListener('resize', () => {
  clearTimeout(resizeTimer);
  resizeTimer = setTimeout(initHeight, 120);
});

$(function() {
  var winW = document.documentElement.clientWidth

  $(".mega_menu_line").css({"height":$(".mega_menu_item_image").height() + "px"})
  $(".js-drawer-open-nav_new").click(function() {
    $(".center-drawer-new").toggleClass("open")
    $(this).parents("#HeaderWrapper").toggleClass("open_dropdown")
    $(this).toggleClass("open")
      var winW = document.documentElement.clientWidth
       if(winW < 769 ){
        $("html").toggleClass("js-drawer-open lock-scroll")
          $("#NavDrawer").toggleClass("drawer--is-open")
        }
   
  })
    $(".js-open-propop").click(function() {
      $("body").addClass("pop")
        $(this).siblings(".protection_item_pop").fadeIn()
    })
  $(".js-open_custom_menu").click(function() {
    $("body").addClass("pop pop_status")
    $(this).parents(".product-block--custom_menu").addClass("custom_menu_open")
    $(this).parents(".product-block--custom_menu").find(".product-block--custom_menu_wrapper").show()
    $(this).parents(".product-block--custom_menu").find(".product-block--custom_menu_wrapper").find(".product-block--custom_menu_container").animate({
        right:0
    }, 500);
  })
  $(".js-close_custom_menu").click(function() {
    $(this).parents(".product-block--custom_menu").removeClass("custom_menu_open")
    $("body").removeClass("pop pop_status")
     $(".product-block--custom_menu_container").animate({
        right:-450
          
      }, 500, function () {
         $(".product-block--custom_menu_wrapper").hide()
      })

  })
  $(".product-block--custom_menu_wrapper").click(function() {
    $(".product-block--custom_menu").removeClass("custom_menu_open")
    $("body").removeClass("pop pop_status")
      $(".product-block--custom_menu_container").animate({
        right:-450
      }, 500, function () {
         $(".product-block--custom_menu_wrapper").hide()
      })
  })
  
  $(".product-block--custom_menu_content").click(function(e) {
    e.stopPropagation();
  })
  // product
  $(".protection_item_content").click(function() {
    let pop_id = $(this).data("pop")
    $(`#${pop_id}`).fadeIn()
    $("body").addClass("pop")
  })
  $(".close_protection_item_pop").click(function(){
    console.log()
    $(this).parents(".protection_item_pop").fadeOut()
    $("body").removeClass("pop")
  })
    $(".color-swatch--with-image-new").click(function(e){
      $(this).addClass("active")
      $(this).siblings(".color-swatch--with-image-new").removeClass("active")
    let image = $(this).data("variant-image")
    let id = $(this).data("variant-id")
    let href = $(this).attr("href")
    if($(`.grid-product__color-image--${id}`) && !$(`.grid-product__color-image--${id}`).hasClass("is-active")){
       $(`.grid-product__color-image--${id}`).siblings(".grid-product__color-image").removeClass("is-active")
      $(`.grid-product__color-image--${id}`).addClass("is-active")
      $(this).parents(".grid-product").find(".grid-product__link").attr("href",href)
    }
    return false
  })
  $(".size-guide-title").click(function(e) {
    e.stopPropagation();
  })
  $(".size-guide-container").click(function(e) {
    e.stopPropagation();
  })
    $(".custom-try-on").click(function(e) {
    e.stopPropagation();
  })
  // $(".close_size-guide-pop").click(function() {
  //   if (winW > 769) {
  //   $(this).parent().css({"transform":"translate(100%)"})
  //   }else{
  //   $(this).parent().css({"transform":"translateY(100%)"})
      
  //   }
  //   setTimeout(()=> {
  //     $(this).parents(".size-guide-pop").fadeOut()
  //     $("body").removeClass("pop")
  //   },200)
  // })
  if ($("body").hasClass("template-collection")) {
       $("body").click(function(){
          if( $(".sort_by_checked").hasClass("open_list")){
             $(".sort_by_checked").removeClass("open_list")
             $(".sort_by_checked").siblings(".sort_by_list").fadeOut()
          }
      })
      $(".sort_by_list").click(function(e){
          e.stopPropagation()
      })
  }
   $("body").click(function(e){
     if($(".variant-dropdown")){
       $(".variant-dropdown").each(function(i,item){
         if($(item).hasClass("open")){
           $(item).removeClass("open")
         }
       })
     }
   })
  $(".variant-dropdown-selected").click(function(e){
    e.stopPropagation();
    let isOpen = $(this).parent().hasClass("open")
    $(".variant-dropdown-selected").parent().removeClass("open")
    if(!isOpen){
      $(this).parent().addClass("open")
    }
  })
  $(".variant-input-new").click(function(e) {
    if($(this).attr("noabled") == undefined  ){
       let value = $(this).attr("value")
      $(this).parents(".variant-input-wrap").find("select").val(value)
      $(this).parents(".variant-input-wrap").find("select").trigger("change")
      $(this).parents(".variant-dropdown").find(".variant-dropdown-value").html(value)
      $(this).parent().find(".variant-input-new ").removeClass("selected")
      $(this).addClass("selected")
    }else{
      e.stopPropagation();
    }
   
  })
 $(".color-swatch-item-input").change(function() {
   let value = $(this).val()
   $(this).parents(".variant-dropdown ").find(".color-swatch-selected").html(value)
   $(this).parents(".variant-input-wrap").find("select").val(value)
   $(this).parents(".variant-input-wrap").find("select").trigger("change")
 })
  if($("body").hasClass("template-product")){
    var ft = 10000000
    if($(".product-form-new").length > 0){
       ft = $(".product-form-new").offset().top - $(window).height() 
    }
    if($(".isShowEngraving_input")){
      $(".isShowEngraving_input").change(function() {
        $(".engraving_box").toggleClass("show_engraving_box")
           var isShow = $(this).is(':checked')
        if(isShow){
          $(".variant__input--engraving-Y").click()
        }else{
          $(".variant__input--engraving-N").click()
        }
      })
        $("#engraving").blur((function(){
          let value = $(this).val()
          $(".engraving_input").val(value)
        }))
       $(".size_item_new").change((function(){
          let value = $(this).val()
          $(".size_new_input").val(value)
        }))
    }
     $(".openStageInfo-pop").click(function(){
          $(".stageInfo-pop").attr("data-open","true")
          $("html").addClass("lock-scroll").addClass("modal-open")
        })
      $(".closestageInfo-pop").click(function() {
          $(".stageInfo-pop").attr("data-open","false")
          $("html").removeClass("lock-scroll").removeClass("modal-open")
      })
        $(".open-pop").click(function(){
          $(this).parents(".product-block--tab-new").siblings(".pop-box").attr("data-open","true")
          $("html").addClass("lock-scroll").addClass("modal-open")
        })
      $(".close-pop").click(function() {
          $(this).parents(".pop-box").attr("data-open","false")
          $("html").removeClass("lock-scroll").removeClass("modal-open")
      })
     $(".openMoreEngraving").click(function(){
          $(".moreEngraving-pop").attr("data-open","true")
          $("html").addClass("lock-scroll").addClass("modal-open")
        })
      $(".moreEngraving-pop").click(function() {
          $(this).attr("data-open","false")
          $("html").removeClass("lock-scroll").removeClass("modal-open")
      })
    $(".inquiry_only_button").click(function(){
        $(".inquiry_only_pop").attr("data-open","true")
        $("html").addClass("lock-scroll").addClass("modal-open")
      })
    $(".contactPreference_item").change(function() {
      let val = $(this).val()
      if (val == 'by E-mail') {
        $(".inquiry_only_pop_item_Email").show()
        $(".inquiry_only_pop_item_Email").find("input").attr("required","required")
        $(".inquiry_only_pop_item_WhatsApp").hide()
        $(".inquiry_only_pop_item_WhatsApp").find("input").removeAttr("required")
      }else{
        $(".inquiry_only_pop_item_Email").hide()
        $(".inquiry_only_pop_item_Email").find("input").removeAttr("required")
        $(".inquiry_only_pop_item_WhatsApp").show()
        $(".inquiry_only_pop_item_WhatsApp").find("input").attr("required","required")
        
      }
    })
    $(".inquiry_only_pop").click(function() {
       $(this).attr("data-open","false")
       $("html").removeClass("lock-scroll").removeClass("modal-open")
    })
    $(".close_inquiry_only_pop").click(function() {
       $(".inquiry_only_pop").attr("data-open","false")
       $("html").removeClass("lock-scroll").removeClass("modal-open")
    })
     $(".inquiry_only_pop_content").click(function(e) {
       e.stopPropagation()
    })

  }
      $(".product-watch-list_title").click(function() {
      if(!$(this).hasClass("active")){
        let index = $(this).index()
        $(this).siblings().removeClass("active")
        $(this).addClass("active")
        $(this).parents(".product-watch-container-content").find(".product-watch-container-content_content").find(".product-watch-list_content").removeClass("active")
        $(this).parents(".product-watch-container-content").find(".product-watch-container-content_content").find(".product-watch-list_content").eq(index).addClass("active")
        $(this).parents(".product-watch-container").find(".product-watch-container-images").find(".product-watch-container-image").removeClass("active")
        $(this).parents(".product-watch-container").find(".product-watch-container-images").find(".product-watch-container-image").eq(index).addClass("active")
      }
    })
  $(".tab_list_item").click(function() {
    if (!$(this).hasClass("active")) {
      let id = $(this).attr("data-control")
      $(".tab_list_item").removeClass("active")
      $(this).addClass("active")
      $(".tab_list_item_content").removeClass("tab_list_item_content_active")
      $(`.tab_list_item_content[data-content-id='tab_list_item_content_${id}']`).addClass("tab_list_item_content_active")
    }
  })
  var winW = document.documentElement.clientWidth
  $(document).scroll(function() {
    let st = $(this).scrollTop()
     if(winW < 768){
         if($("body").hasClass("template-product")){
            if(st > ft){
                $(".product-form-new-content").removeClass("form-fixed")
              }else{
                if(!$(".product-form-new-content").hasClass("form-fixed")){
                  $(".product-form-new-content").addClass("form-fixed")
                }
            }
          }
     
     }
  })
  // $(".open_omnisend").click(function(){
  //   console.log(123)
  // })
  $(".appointment_progress_item").click(function() {
    if(!$(this).hasClass("active")){
      let index = $(this).index(".appointment_progress_item")
      $(this).parents(".page-width").find(".appointment_content_item").removeClass("active")
      $(this).parents(".page-width").find(".appointment_content_item").eq(index).addClass("active")
      $(this).parent().find(".appointment_progress_item").removeClass("active")
      $(this).parent().find(".appointment_progress_item").eq(index).addClass("active")
    }
  })
  $(".appointment_content_item_content_button").click(function(){
    $(this).parents(".appointment_content").find(".appointment_content_item").eq(0).removeClass("active")
    $(this).parents(".appointment_content").find(".appointment_content_item").eq(1).addClass("active")
    $(this).parents(".page-width").find(".appointment_progress").find(".appointment_progress_item").eq(0).removeClass("active")
    $(this).parents(".page-width").find(".appointment_progress").find(".appointment_progress_item").eq(1).addClass("active")
  })

  // var spop = localStorage.getItem("npop") || null
  // if(!spop){
  //   setTimeout(function() {
  //     $(".subscribeBox-pop").fadeIn()
  //     $("body").addClass("pop")
  //   },5000)
  // }
  // $(".close-subscribeBox-pop").click(function() {
  //     $(".subscribeBox-pop").fadeOut()
  //     $("body").removeClass("pop")
  //     localStorage.setItem('npop', "t")
  // })
  // $(".copy-code").click(function() {
  //     var element = document.getElementById("pop-code-name")
  //         element.select();
  //         element.setSelectionRange(0, element.value.length);
  //         document.execCommand("copy");
  //         var url = window.location.pathname + window.location.search;
  //         var codeName = $(".copy-code").attr("code-name");
  //         localStorage.setItem('npop', "t");
  //         window.location.href = "/discount/" + escape(codeName) + "?redirect=" + url;
  // })
  // $(".openSubscriptPop").click(function() {
  //      $(".subscribeBox-pop").fadeIn()
  //      $("body").addClass("pop")
  // })
  $(".custom-tab-title-new").click(function(){
    if (!$(this).hasClass("active")) {
       $(this).siblings().removeClass("active")
        $(this).addClass("active")
      let index = $(this).index()
      $(this).parents(".custom-tab-wrapper").find(".custom-tab-content-new").removeClass("active")
      $(this).parents(".custom-tab-wrapper").find(".custom-tab-content-new").eq(index).addClass("active")
    }
  })
    $(".variant__label_coll_title").click(function(e){
    e.stopPropagation()
    let coll_content = $(this).siblings(".variant__label_coll_content")
    $(this).toggleClass("open")
    if(coll_content.css("display")=="block"){
      coll_content.slideUp()
    }else{
      coll_content.slideDown()
    }
  })
})

function changeTab(t) { 
    if (!$(t).hasClass("active")) {
      let index = $(t).index()
      $(t).siblings().removeClass("active")
      $(t).addClass("active")
      $(t).parent().siblings(".custom-size-guide-contents").find(".custom-size-guide-content").hide()
      $(t).parent().siblings(".custom-size-guide-contents").find(".custom-size-guide-content").eq(index).show()
    }
}
function play_video(el) {
    const video = el.nextElementSibling;
  if (video && video.tagName.toLowerCase() === 'video') {
    video.play();
    el.style.display = 'none';
  }
}
function open_cart_pop(id) {
    $(`#${id}`).fadeIn()
  $("body").addClass("pop")
}
function close_cart_bottom_pop(e) {
  $(e).parents(".custom_cart-drawer_bottom_pop").fadeOut()
  $("body").removeClass("pop")
}
function set_readmore(is_drawer) {
   const items = document.querySelectorAll('.cart-variants-pro-box');
  const readMoreBtns = document.querySelectorAll('.cart-variants-pro-read-more');
  items.forEach((item, index) => {
    const readMoreBtn = readMoreBtns[index];
    var limit_height = 20
    if (document.documentElement.clientWidth <= 750) {
      limit_height = 36
    }
    if (is_drawer) {
      limit_height = 36
    }
    if (item.scrollHeight > limit_height) {
      readMoreBtn.style.display = 'block';
    }
   readMoreBtn.addEventListener('click', () => {
      item.classList.toggle("cart-variants-pro-unset");
    });
  });
}
if (document.body.classList.contains('template-cart')) {
  set_readmore(false);
}

class CustomCountdown extends HTMLElement {
  constructor() {
    super();
    this.date = this.getAttribute("data-date")
    this.endText = this.getAttribute("data-end")
    this.isDst = this.getAttribute("data-dst") === "true";
    this.isEst = this.getAttribute("data-est") === "true";
    this.diff_time = 5
    this.timeList = this.date.split("-")
    this.targetUTCDate = new Date(Date.UTC(Number(this.timeList[0]), Number(this.timeList[1]) - 1, Number(this.timeList[2]),  Number(this.timeList[3] || 0), 0, 0));
    this.initInterval()
    this.timer = setInterval(this.initInterval.bind(this), 1000);
  }
  initInterval(){
    if (this.isDst) {
      if (this.isEst) {
    this.diff_time = 4
        
      }else{
    this.diff_time = 7
        
      }
    }else{
        if (this.isEst) {
    this.diff_time = 5
        
      }else{
    this.diff_time = 8
        
      }
    }
        const now = new Date();
        const utcMinus7Now = new Date(now.getTime() - this.diff_time * 60 * 60 * 1000);
        const diff = this.targetUTCDate - utcMinus7Now;

        if (diff <= 0) {
          this.innerHTML = this.endText
          this.classList.add("custom-countdown-end-status")
            clearInterval(this.timer);
            return;
        }
        let days = Math.floor(diff / (1000 * 60 * 60 * 24));
        let hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        let minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
        let seconds = Math.floor((diff % (1000 * 60)) / 1000);
        days = days >= 10 ? days : "0" + days
        hours = hours >= 10 ? hours : "0" + hours
        minutes = minutes >= 10 ? minutes : "0" + minutes
        seconds = seconds >= 10 ? seconds : "0" + seconds
        this.querySelector(".custom-countdown-new-days").innerHTML = days
        this.querySelector(".custom-countdown-new-hours").innerHTML = hours
        this.querySelector(".custom-countdown-new-mins").innerHTML = minutes
        this.querySelector(".custom-countdown-new-seconds").innerHTML = seconds
     
  }
 
}

customElements.define('custom-countdown', CustomCountdown);
class CustomSubmitForm extends HTMLElement {
  constructor() {
    super();
    this.formId = this.getAttribute("data-id")
    this.initForm()
  }
  initForm(){
    if (window.location.search.includes("customer_posted=true")) {
      let anchor = window.location.hash.substring(1)
      if (anchor == this.formId) {
        this.querySelector(".newsletter-form-container").style.display = "none"
        this.querySelector(".note--success").style.display = "block"
      }else{
        this.querySelector(".newsletter-form-container").style.display = "block"
        this.querySelector(".note--success").style.display = "none"
      }
    }else{
      this.querySelector(".newsletter-form-container").style.display = "block"
      this.querySelector(".note--success").style.display = "none"
    }
  }
}
customElements.define('custom-submit-form', CustomSubmitForm);

class CustomCountdownNode extends HTMLElement {
  constructor() {
    super();
    this.startHour = this.getAttribute("data-node-start")*1
    this.endHour = this.getAttribute("data-node-end")*1
    this.startLabel = this.getAttribute("data-start-label")
    this.endLabel = this.getAttribute("data-end-label")
    this.hideEnd = this.getAttribute("data-hide-end") === "true"
    this.days = this.getAttribute("data-days") === "true"
    this.hourNode = this.getAttribute("data-hour-node")*1 || 0
    console.log(this.days);
    
    if (this.days) {
      this.updateDayCountdown();
      this.timer = setInterval(this.updateDayCountdown.bind(this), 1000);
    }else{
      this.updateCountdown();
      this.timer = setInterval(this.updateCountdown.bind(this), 1000);
    }
  }
  updateDayCountdown(){
    let now = new Date(new Date().toISOString())
    let end = new Date(now)
    end.setUTCHours(this.hourNode, 0, 0, 0);
    let diffTime = null;
    let currentHour = now.getUTCHours()
    if (currentHour >= this.hourNode ) {
      end.setUTCDate(new Date(now).getUTCDate() + 1);
    }
    diffTime = end - now
    this.render(diffTime, "活动进行");
  }
  updateCountdown(){
    let now = new Date(new Date().toISOString())
        let currentHour = now.getUTCHours()
         if (currentHour < this.startHour ) {
          let start = new Date(now);
          start.setUTCHours(this.startHour);
          start.setUTCMinutes(0);
          start.setUTCSeconds(0);
          let diff = start - now;
          this.render(diff, "活动进行");
          this.querySelector(".custom-countdown-new-countdown-label").innerHTML = this.startLabel
          this.closest(".countdown-with-products-section")?.classList.remove("countdown-with-products-end-status-wrapper")
          if (this.hideEnd) {
             this.classList.remove("d-none")
          }
        }else if(currentHour >= this.endHour){
          let start = new Date(now);
          start.setUTCDate(new Date(now).getUTCDate() + 1);
          start.setUTCHours(this.startHour);
          start.setUTCMinutes(0);
          start.setUTCSeconds(0);
          let diff = start - now;
          this.render(diff, "活动进行");
          this.querySelector(".custom-countdown-new-countdown-label").innerHTML = this.startLabel
          this.closest(".countdown-with-products-section")?.classList.remove("countdown-with-products-end-status-wrapper")
           if (this.hideEnd) {
             this.classList.remove("d-none")
          }
        }else{
           let end = new Date(now);
           end.setUTCHours(this.endHour);
            end.setUTCMinutes(0);
            end.setUTCSeconds(0);
            let diff = end - now;
          this.render(diff, "活动结束");
          this.querySelector(".custom-countdown-new-countdown-label").innerHTML = this.endLabel
          this.closest(".countdown-with-products-section")?.classList.add("countdown-with-products-end-status-wrapper")
          if (this.hideEnd) {
             this.classList.add("d-none")
          }
        }
      
  }
 
  render(diff, label) {
    console.log(label);
    
    let days = Math.floor(diff / (1000 * 60 * 60 * 24));
    let hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    let minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
    let seconds = Math.floor((diff % (1000 * 60)) / 1000);
    days = days >= 10 ? days : "0" + days
    hours = hours >= 10 ? hours : "0" + hours
    minutes = minutes >= 10 ? minutes : "0" + minutes
    seconds = seconds >= 10 ? seconds : "0" + seconds
    this.querySelector(".custom-countdown-new-days").innerHTML = days
    this.querySelector(".custom-countdown-new-hours").innerHTML = hours
    this.querySelector(".custom-countdown-new-mins").innerHTML = minutes
    this.querySelector(".custom-countdown-new-seconds").innerHTML = seconds
  }
}

customElements.define('custom-countdown-node', CustomCountdownNode);

class customPop extends HTMLElement {
  constructor() {
    super();
    this.button = this.querySelector(".custom-pop-button")
    this.popWrapper = this.querySelector(".custom-pop-container")
    this.closeButton = this.querySelector(".custom-pop-close")
  }
  connectedCallback(){
    this.button.addEventListener("click",this.open.bind(this))
    this.closeButton.addEventListener("click",this.close.bind(this))
      this.popWrapper.addEventListener("click", (e) => {
        if (e.target === this.popWrapper) {
          this.close();
        }
      });
  }
  open() {
      $(this).find(".custom-pop-container").fadeIn(function() {
        $(this).find(".custom-pop-content").css({"transform":"translate(0)"})
        $("body").addClass("pop custom-pop-open");
      })
  }
  close() {
       if (document.documentElement.clientWidth > 769) {
        $(this).find(".custom-pop-content").css({"transform":"translate(100%)"})
       }else{
        $(this).find(".custom-pop-content").css({"transform":"translateY(100%)"})
       }
       setTimeout(()=> {
         $(this).find(".custom-pop-container").fadeOut()
        $("body").removeClass("pop custom-pop-open");
       },200)
  }
}
customElements.define('custom-pop', customPop);
